import React from "react";
import { History } from "history";
import NumberFormat from "react-number-format";
import {
  Box,
  Combo,
  CampoEstatico,
  TipoCampoEstatico,
  Row,
  Col,
  Botao,
  Form,
  Alerta,
  TipoAlerta,
  Modal,
  PosicaoTituloCampoEstatico,
} from "@intechprev/componentes-web";

import { Page } from "../../..";
import { NumFuncionalidade } from "../../../Page";
import { PlanoVinculadoEntidade, ContratoEntidade, ParametrosSimulacao, NaturezaEntidade } from "../../../../entidades";
import { PlanoService, EmprestimoService } from "../../../../services";
import { Link } from "react-router-dom";
import { ListaPlanos } from "../../../../components";
import { DMN_CATEGORIA } from "../../../../domains";
import moment from "moment";

export interface IParametrosSimulacao {
  valorSolicitado: number;
  valorMargemConsignavel: number;
  plano: string;
  emprestimos: Array<ContratoEntidade>;
}

interface IProps {
  history?: History;
}

interface IState {
  cdPlano: string;
  plano: PlanoVinculadoEntidade;
  listaPlanos: Array<PlanoVinculadoEntidade>;
  carencia: number;
  listacarencias: Array<any>;

  emprestimos: Array<ContratoEntidade>;
  naturezas: Array<NaturezaEntidade>;
  natureza: string;
  CdModal: number;

  valorSolicitado: number;
  valorMargemConsignavel: number;
  margemPreenchida: boolean;
  limiteMaximo: number;
  limiteUnico: number;
  dataCredito: string;
  recursoUtilizado: number;
  valorDisponivel: number;

  modalValorMargemConsignavel: boolean;
  modalNovacao: boolean;

  ativoOuAssistido: boolean;
  erro: string;
}

export class EmprestimoSimulador extends React.Component<IProps, IState> {

  private page = React.createRef<Page>();
  private form = React.createRef<Form>();
  private alert = React.createRef<Alerta>();

  state: IState = {
    cdPlano: "",
    listaPlanos: [],
    carencia: 0,
    listacarencias: [
      {
        Key: 0,
        Value: "CARÊNCIA NORMAL"
      },
      {
        Key: 30,
        Value: "CARÊNCIA ESTENDIDA - 30 DIAS"
      },
      {
        Key: 60,
        Value: "CARÊNCIA ESTENDIDA - 60 DIAS"
      },
      {
        Key: 90,
        Value: "CARÊNCIA ESTENDIDA - 90 DIAS"
      }
    ],
    plano: new PlanoVinculadoEntidade(),

    emprestimos: [],

    valorSolicitado: 0,
    valorMargemConsignavel: 0,
    margemPreenchida: false,

    naturezas: [],
    natureza: "",
    CdModal: 0,
    limiteMaximo: 0,
    limiteUnico: 0,
    dataCredito: "",
    recursoUtilizado: 0,
    valorDisponivel: 0,
    ativoOuAssistido: false,
    modalValorMargemConsignavel: false,
    modalNovacao: false,
    erro: ""
  };

  componentDidMount = async () => {
    await this.page.current.loading(true);
    try {

      var listaPlanos = await PlanoService.Buscar();

      this.setState({
        listaPlanos,
      });

      // await this.carregarDados();

    } catch (err) {
      const erro: any = err;
      this.setState({ erro: (erro.response ? (erro.response.data) : erro) });
    }
    finally {
      await this.page.current.loading(false);
    }
  };

  separarFolha = (folha: any) => {
    let novaFolha: any = {
      provento: [],
      desconto: []
    }

    let countP = 0;
    let countD = 0;

    for (let f = 0; f < folha.length; f++) {
      if (folha[f].RUBRICA_PROV_DESC === "P") {
        novaFolha.provento[countP] = folha[f];
        countP++;
      }
      if (folha[f].RUBRICA_PROV_DESC === "D") {
        novaFolha.desconto[countD] = folha[f];
        countD++;
      }
    }

    return novaFolha;
  }

  carregarDados = async (Plano: PlanoVinculadoEntidade) => {
    await this.page.current.loading(true);
    try {
      // if (Plano.CD_CATEGORIA !== DMN_CATEGORIA.ASSISTIDO)
      //   return this.setState({
      //     plano: Plano,
      //     cdPlano: Plano.CD_PLANO,
      //     ativoOuAssistido: ([DMN_CATEGORIA.ATIVO, DMN_CATEGORIA.ASSISTIDO] as string[]).includes(Plano.CD_CATEGORIA),
      //   });
      // if (this.state.cdPlano === "") {
      //   await this.setState({
      //     cdPlano: this.state.listaPlanos[0].CD_PLANO,
      //   });
      // }

      // var plano = this.state.listaPlanos.filter((plano) => plano.CD_PLANO === this.state.cdPlano);

      var { limiteMaximo, limiteUnico, dataCredito, margemConsignavel, valorDisponivel, recursoUtilizado, naturezas } = await EmprestimoService.BuscarLimiteUnicoDataCredito(Plano.CD_PLANO);

      const emprestimos = await EmprestimoService.BuscarAtivos(moment(dataCredito, "DD/MM/yyyy").format("DD.MM.yyyy"));

      var valorMargemConsignavel = 0;

      if (margemConsignavel != null) {
        valorMargemConsignavel = Number(margemConsignavel);
        await this.setState({
          margemPreenchida: true,
        });
      }

      await this.setState({
        emprestimos,
        limiteMaximo,
        limiteUnico,
        dataCredito,
        recursoUtilizado,
        valorDisponivel,
        valorMargemConsignavel,
        naturezas,
        natureza: naturezas.length > 0 ? naturezas[0].CD_NATUR : "",
        plano: Plano,
        cdPlano: Plano.CD_PLANO,
        ativoOuAssistido: ([DMN_CATEGORIA.ATIVO, DMN_CATEGORIA.ASSISTIDO] as string[]).includes(Plano.CD_CATEGORIA)
      });

    } catch (err) {
      const erro: any = err;
      await this.setState({ erro: (erro.response ? (erro.response.data) : erro) });
    }
    finally {
      await this.page.current.loading(false);
    }
  };

  carregarNatureza = async () => {
    try {
      const natur = this.state.naturezas.filter(x => x.CD_NATUR === Number(this.state.natureza));
      if (natur.length > 0) {
        const modal = natur[0].CD_MODAL;
        this.setState({
          CdModal: modal
        })
      }
    } catch (err) {
      const erro: any = err;
      this.setState({ erro: (erro.response ? (erro.response.data) : erro) });
    }
  }

  continuar = async () => {
    try {
      await this.alert.current.limparErros();
      await this.form.current.validar();

      if (this.state.valorSolicitado <= 0) {
        await this.alert.current.adicionarErro("O valor solicitado não pode ser menor ou igual a zero.");
        return;
      }

      if (this.state.valorSolicitado && this.state.valorMargemConsignavel) {
        if (this.state.valorSolicitado > Number(this.state.valorDisponivel.toFixed(2)))
          await this.alert.current.adicionarErro('O valor solicitado não pode ser superior ao valor "Disponível".');
      }

      if (!this.state.natureza) {
        await this.alert.current.adicionarErro("Escolha uma Natureza para realizar a simulação.")
      }

      if (this.alert.current.state.mensagem.length === 0 && this.alert.current.props.mensagem.length === 0) {
        var dados: ParametrosSimulacao = {
          valorSolicitado: this.state.valorSolicitado,
          ValorMargem: Number(this.state.valorMargemConsignavel),
          CdPlano: this.state.plano.CD_PLANO,
          Carencia: this.state.carencia,
          emprestimos: this.state.emprestimos,
          CdNatur: Number(this.state.natureza),
          CdModal: this.state.CdModal
        };

        localStorage.setItem("emprestimo-parametros", JSON.stringify(dados));
        this.props.history.push("/emprestimo/simuladorprestacoes");
      }
    } catch (err) {
      const erro: any = err;
      this.setState({ erro: (erro.response ? (erro.response.data) : erro) });
    }
  };

  render() {
    return (
      <Page Funcionalidade={NumFuncionalidade.EMPRESTIMOS_SIMULAÇÃO} {...this.props} ref={this.page}>
        {this.state.erro !== "" && (
          <div className={"alert alert-info"} style={{ "color": "#000 !important" }} dangerouslySetInnerHTML={{ __html: this.state.erro }} />
        )}

        {this.state.erro === "" && (<>
          <h3>Bem-Vindo ao Simulador de Empréstimos da São Francisco!</h3>
          {/* <h5>Ao final da sua simulação você poderá realizar o requerimento do seu empréstimo diretamente por aqui, de forma on-line e segura!</h5> */}

          <Box titulo={"Selecione um Plano para a Simulação"}>
            {/* <Combo
              contexto={this}
              nome={"cdPlano"}
              valor={this.state.cdPlano}
              opcoes={this.state.listaPlanos}
              padrao={this.state.cdPlano}
              onChange={this.carregarDados}
              nomeMembro={"DS_PLANO"}
              valorMembro={"CD_PLANO"}
              textoVazio={"Escolha um Plano para Realizar a Simulação"}
            /> */}
            <ListaPlanos
              planos={this.state.listaPlanos}
              onChange={this.carregarDados}
              cdPlanoAtivo={this.state.cdPlano}
            />
          </Box>

          {this.state.naturezas.length > 0 && this.state.naturezas[0].CONSIDERAR_CARENCIA_CONCESSAO === "S" &&
            <Box titulo={"Selecione uma Carência para a Simulação"}>
              <Combo
                contexto={this}
                nome={"carencia"}
                valor={this.state.carencia}
                opcoes={this.state.listacarencias}
                padrao={this.state.carencia}
                nomeMembro={"Value"}
                valorMembro={"Key"}
              />
            </Box>
          }

          {this.state.plano.CD_PLANO && (
            <Box titulo={`Empréstimo ${this.state.plano.DS_PLANO}`}>
              {!this.state.ativoOuAssistido && (
                <Alerta
                  tipo={TipoAlerta.danger}
                  mensagem={"Empréstimos São Francisco disponíveis apenas para quem é Ativo ou Assistido no plano de benefícios."}
                />
              )}

              {this.state.ativoOuAssistido && (
                <>
                  {/* <p>
                    {"Visite a página de "}
                    <Link className={"text-secondary"} to={"/documentos"}>
                      {"Pastas e Arquivos Disponibilizados"}
                    </Link>
                    {" para visualizar o regulamento de empréstimo."}
                  </p> */}
                  <Row className={"text-center"}>
                    {/* {this.state.cdPlano !== "0001" && this.state.plano.CD_CATEGORIA !== "4" && ( */}
                    {/* <>
                      <Col>
                        <Box>
                          <h4 style={{ fontWeight: "bold" }}>Limite Máximo Bruto</h4>
                          {/* <p style={{ fontSize: 12 }}>70% do Saldo da Conta Participante (Excluídos os recursos portados)</p> *}
                          <h3 className={"text-primary"}>
                            <CampoEstatico valor={this.state.limiteMaximo} tipo={TipoCampoEstatico.dinheiro} />
                          </h3>
                        </Box>
                      </Col>
                    </> */}
                    {/* <Col>
                      <Box>
                        <h4 style={{ fontWeight: "bold" }}>Limite Líquido</h4>
                        <p style={{ fontSize: 12 }}>Maior valor de empréstimo para seu plano</p>
                        <h3 className={"text-primary"}>
                          <CampoEstatico valor={this.state.limiteUnico} tipo={TipoCampoEstatico.dinheiro} />
                        </h3>
                      </Box>
                    </Col> */}
                    {/* <Col>
                      <Box>
                        <h4 style={{ fontWeight: "bold" }}>Data de Crédito</h4>
                        <p style={{ fontSize: 12 }}>Data que você receberá o seu empréstimo</p>
                        <h3 className={"text-primary"}>
                          <CampoEstatico valor={this.state.dataCredito} />
                        </h3>
                      </Box>
                    </Col> */}
                  </Row>
                  <Row className={"text-center"}>
                    <Col tamanho={"8"}>
                      <Row>
                        <Col>
                          <Box>
                            <h4 style={{ fontWeight: "bold" }}>Empréstimo(s) ativo(s)</h4>
                            <p style={{ fontSize: 12 }}>Saldo Devido</p>
                            <h3 className={"text-secondary"}>
                              <CampoEstatico valor={this.state.recursoUtilizado} tipo={TipoCampoEstatico.dinheiro} />
                            </h3>
                          </Box>
                        </Col>
                        {/* <Col>
                      <Box>
                        <h4 style={{ fontWeight: "bold" }}>Disponível</h4>
                        <p style={{ fontSize: 12 }}>
                          Valor que você pode requerer
                          <br />
                          <br />
                        </p>
                        <h3 className={"text-success"}>
                          <CampoEstatico valor={this.state.valorDisponivel} tipo={TipoCampoEstatico.dinheiro} />
                        </h3>
                      </Box>
                    </Col> */}
                        <Col>
                          <Box>
                            <h4 style={{ fontWeight: "bold" }}>{"Márgem Consignável"}</h4>
                            <p style={{ fontSize: 12 }}>Valor máximo de Prestação</p>
                            <h3 className={"text-success"}>
                              <CampoEstatico
                                valor={this.state.valorMargemConsignavel}
                                tipo={TipoCampoEstatico.dinheiro}
                              />
                            </h3>
                          </Box>
                        </Col>


                      </Row>

                      {this.state.naturezas.length > 0 && <>
                        <Row>
                          <Col>
                            <Box titulo={"Selecione uma Natureza para a Simulação *"}>
                              <Combo
                                contexto={this}
                                nome={"natureza"}
                                valor={this.state.natureza}
                                opcoes={this.state.naturezas}
                                // padrao={this.state.natureza}
                                onChange={this.carregarNatureza}
                                textoVazio={"Selecione uma Natureza para a Simulação"}
                                nomeMembro={"DS_NATUR"}
                                valorMembro={"CD_NATUR"}
                              />
                            </Box>
                          </Col>

                          <Col>
                          </Col>
                        </Row>
                      </>}
                    </Col>

                    {this.state.naturezas.length > 0 &&
                      <Col>
                        <Box>
                          <h4 style={{ fontWeight: "bold" }}>{"Limite Liquido Permitido"}</h4>
                          {this.state.naturezas.map((natur: NaturezaEntidade, index: number) => {
                            return (<>
                              <p style={{ fontSize: 12 }}>{natur.DS_NATUR}</p>
                              <h3 className={"text-secondary"}>
                                <CampoEstatico
                                  key={index}
                                  tipo={TipoCampoEstatico.dinheiro}
                                  posicaoTitulo={PosicaoTituloCampoEstatico.cima}
                                  // titulo={natur.DS_NATUR}
                                  valor={natur.LimiteCalculado}
                                />
                              </h3>
                            </>)
                          })}
                        </Box>
                      </Col>
                    }
                  </Row>

                  <Box titulo={"Parâmetros para Simulação"}>
                    <Form ref={this.form}>
                      <Row formGroup>
                        <Col className="col-lg-12">
                          <b>
                            <label htmlFor="valorSolicitado">Digite Aqui o Valor Líquido Desejado de Empréstimo *</label>
                          </b>
                        </Col>

                        <Col className="col-lg-12">
                          <NumberFormat
                            name={"valorSolicitado"}
                            id={"valorSolicitado"}
                            className={"form-control"}
                            thousandSeparator={"."}
                            decimalSeparator=","
                            allowedDecimalSeparators={["."]}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            value={this.state.valorSolicitado}
                            onValueChange={(e) => this.setState({ valorSolicitado: Number(e.value) })}
                          />
                        </Col>
                      </Row>

                      {/* <Row formGroup>
                        <Col className="col-lg-12">
                          <b>
                            <label htmlFor="valorSolicitado">
                              Margem Consignável *{" "}
                              <small>
                                (Valor da margem a ser confirmado pela fonte pagadora, após a data do efetivo pagamento do mês do crédito do empréstimo)
                              </small>
                            </label>
                          </b>
                        </Col>

                        <Col className="col-lg-12">
                          <div className="input-group">
                            <NumberFormat
                              name={"valorMargemConsignavel"}
                              id={"valorMargemConsignavel"}
                              className={"form-control"}
                              thousandSeparator={"."}
                              decimalSeparator=","
                              allowedDecimalSeparators={["."]}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              value={this.state.valorMargemConsignavel}
                              disabled={this.state.margemPreenchida}
                              onValueChange={(e) => this.setState({ valorMargemConsignavel: Number(e.value) })}
                            />
                            <div className="input-group-append">
                              <Botao
                                titulo="O que é isso?"
                                onClick={() =>
                                  this.setState({
                                    modalValorMargemConsignavel: !this.state.modalValorMargemConsignavel,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row> */}

                      <Modal
                        onClose={() =>
                          this.setState({
                            modalValorMargemConsignavel: !this.state.modalValorMargemConsignavel,
                          })
                        }
                        onConfirm={() =>
                          this.setState({
                            modalValorMargemConsignavel: !this.state.modalValorMargemConsignavel,
                          })
                        }
                        visivel={this.state.modalValorMargemConsignavel}
                        titulo={"O que é a Margem Consignável?"}
                      >
                        Margem Consignável é 30% do valor máximo da renda de um trabalhador, aposentado, pensionista ou servidor público que pode ser
                        comprometido do seu salário ou benefício mensal em um empréstimo consignado, no qual o valor do empréstimo é descontado
                        diretamente da folha de pagamento, contracheque ou conta de benefício INSS.
                        <br />
                        <br />
                        Você encontrará margem consignável no seu contracheque.
                      </Modal>

                      <Modal
                        onClose={() =>
                          this.setState({
                            modalNovacao: !this.state.modalNovacao,
                          })
                        }
                        onConfirm={() =>
                          this.setState({
                            modalNovacao: !this.state.modalNovacao,
                          })
                        }
                        visivel={this.state.modalNovacao}
                        titulo={"O que é a Novação de Dívida?"}
                      >
                        Novação é a transformação de uma dívida em outra, com extinção da antiga. Desta forma surge uma nova dívida do devedor em
                        relação ao credor, com o desaparecimento da original.
                        <br />
                        <br />
                        Dá-se a novação:
                        <br />
                        <br />
                        <ul>
                          <li>Quando o devedor contrai com o credor nova dívida para extinguir e substituir a anterior;</li>
                          <li>Quando novo devedor sucede ao antigo, ficando este quite com o credor;</li>
                          <li>Quando, em virtude de obrigação nova, outro credor é substituído ao antigo, ficando o devedor quite com este.</li>
                        </ul>
                      </Modal>

                      {this.state.emprestimos.length > 0 && (
                        <>
                          <p className={"mt-5"}>
                            Você já possúi {this.state.emprestimos.length} contratos ativos. Esse contrato será reformado - Novação (
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  modalNovacao: !this.state.modalNovacao,
                                });
                              }}
                            >
                              O que é isso?
                            </a>
                            )
                          </p>
                          <table className={"table"}>
                            <thead>
                              <tr>
                                <th>Nº/Ano</th>
                                <th>Crédito</th>
                                <th>Valor Solicitado</th>
                                <th>Saldo Devedor</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.emprestimos.map((info: ContratoEntidade, index: number) => {
                                return (
                                  <tr key={index}>
                                    <td>{`${info.NUM_CONTRATO}/${info.ANO_CONTRATO}`}</td>
                                    <td>{info.DT_CREDITO}</td>
                                    <td>
                                      <CampoEstatico valor={info.VL_SOLICITADO} tipo={TipoCampoEstatico.dinheiro} />
                                    </td>
                                    <td>
                                      <CampoEstatico
                                        valor={info.SaldoDevedor.ValorReformado}
                                        tipo={TipoCampoEstatico.dinheiro}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </>
                      )}

                      <Botao titulo={"Calcular Prazos e Prestações"} onClick={this.continuar} submit />

                      <br />
                      <br />
                      <Alerta ref={this.alert} padraoFormulario tipo={TipoAlerta.danger} tamanho={"6"} />

                    </Form>
                    <Alerta tipo={TipoAlerta.info} tamanho={"6"} mensagem={"* campos obrigatórios."} />
                  </Box>
                </>
              )}
            </Box>
          )}

          {/* {this.state.plano.CD_PLANO && this.state.plano.CD_CATEGORIA !== DMN_CATEGORIA.ASSISTIDO && <Alerta tipo={TipoAlerta.danger} mensagem={"Simulador de Empréstimo disponível apenas para participantes na categoria de Assistido."} />} */}
        </>)}
      </Page>
    );
  }
}
